<template>
  <div>
    <StoreInit :store="'cart'">
      <NuxtLayout />
    </StoreInit>

    <ShoppingCartSlideover />
    <UNotifications />
    <UModals />
    <USlideovers />
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
const router = useRouter();
const { $emitEvent } = useNuxtApp();

// TODO - Add a better title and description on separate pages
useSeoMeta({
  title: () => `${config.public.companyProfileName} Bestillingsskjema`,
  description: () =>
    `Bestilling av ${config.public.companyProfileName} sine tjenester`,
});

useFavicon(config.public.faviconFile, {
  rel: "icon",
});

router.afterEach(() => {
  $emitEvent("close-all-overlays");
});
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
